var React = require('react');

function Travel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.38 0H4C1.8 0 0.02 1.8 0.02 4V12C2.22 12 4 13.8 4 16C4 18.2 2.22 20 0 20V28C0 30.2 1.8 32 4 32H36C38.2 32 40 30.2 40 28V4C40 1.8 38.38 0 36.38 0ZM31.46 18.6L13.74 23.32L10.42 17.56L12.28 17.06L14.8 19.04L19.58 17.76L14.78 9.44L17.58 8.68L25.6 16.16L30.48 14.86C31.5 14.58 32.56 15.2 32.84 16.22C33.1 17.24 32.5 18.3 31.46 18.6Z","fill":"currentColor"}));
}

Travel.defaultProps = {"width":"40","height":"32","viewBox":"0 0 40 32","fill":"none"};

module.exports = Travel;

Travel.default = Travel;
